import { styled } from "@ff/ui";
import Box from "@ff/ui/Box";
import { colors } from "client/v3/typography";

export default styled(Box)(({theme}) => ({
  width: '100%',
  padding: '32px 16px',
  backgroundColor: colors.background1,
  borderTop: colors.border5,
  backdropFilter: 'blur(11px)',

  display: 'flex',
  flexDirection: 'column',
  gap: '16px',

  [theme.mediaQueries.md]: {
    padding: '32px 48px',
    alignItems: 'stretch',
  }
}));
